import React from "react";

// bars: [{ value, label, color }]
function BarChart({ bars = [], height = 120 }) {
  const max = Math.max(1, ...bars.map((b) => Math.max(0, b.value)));
  const barW = 100 / bars.length;
  return (
    <div style={{ width: "100%" }}>
      <svg width="100%" height={height} viewBox={`0 0 100 ${height}`} preserveAspectRatio="none">
        <defs>
          {bars.map((b, i) => (
            <linearGradient key={i} id={`bg${i}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={b.color || "#00e5ff"} stopOpacity="1" />
              <stop offset="100%" stopColor={b.color || "#00e5ff"} stopOpacity="0.25" />
            </linearGradient>
          ))}
        </defs>
        {bars.map((b, i) => {
          const h = (Math.max(0, b.value) / max) * (height - 24);
          const x = i * barW + barW * 0.15;
          const w = barW * 0.7;
          const y = height - 20 - h;
          return (
            <g key={i}>
              <rect
                x={x}
                y={y}
                width={w}
                height={h}
                fill={`url(#bg${i})`}
                rx="1"
                style={{
                  filter: `drop-shadow(0 0 3px ${b.color || "#00e5ff"})`,
                }}
                preserveAspectRatio="none"
              />
            </g>
          );
        })}
      </svg>
      <div style={{ display: "grid", gridTemplateColumns: `repeat(${bars.length}, 1fr)`, gap: 2, marginTop: 6 }}>
        {bars.map((b, i) => (
          <div
            key={i}
            style={{
              fontSize: 9,
              color: "var(--text-muted)",
              textAlign: "center",
              textTransform: "uppercase",
              letterSpacing: "0.02em",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            title={b.label}
          >
            {b.label}
          </div>
        ))}
      </div>
    </div>
  );
}

export default BarChart;
